export default "__VITE_ASSET__B264dNVO__"